export const AccesoBackOfficeOptions = [
  "Asistencias",
  "Clientes",
  "Proveedores",
  "TiposAsistencia",
  "Pagos",
  "Usuarios",
  "CambioEspecial",
  "Calidad",
  "AltaProveedores",
  "DescargarProveedores",
  "AdminLibrary", // Permite subir archivos a la librería en cabina
  "CostoMayor", // Permite cambiar el costo de una asistencia a uno menor // Para el costo menor todos pueden actualmente
  "CambioProveedor",
  "Reportes",
];

export const ACCION_EXITOSA = "Accion Exitosa";
export const EERROR_ENVIO = "Error de Envío";

export const TIPOS_ORDEN_PAGO = {
  1: 'Normal',
  2: 'Pago Directo',
  3: 'Concesionados'
};

export const cuentaEspecialGNPOpciones = [
  { texto: "DACERO", valor: "DACERO" },
  { texto: "DANONE", valor: "DANONE" },
  { texto: "EL ORO", valor: "EL ORO" },
  { texto: "PFS", valor: "PFS" },
  { texto: "SHCP", valor: "SHCP" },
  { texto: "RENT A MATIC ITZA", valor: "RENT A MATIC ITZA" },
  { texto: "TEQUILA SAUZA", valor: "TEQUILA SAUZA" },
  { texto: "AUTOFLETES CHIHUAHUA", valor: "AUTOFLETES CHIHUAHUA" },
  { texto: "ELEMENT", valor: "ELEMENT" },
  { texto: "CONSERVAS LA COSTEÑA", valor: "CONSERVAS LA COSTEÑA" },
  { texto: "ALPURA", valor: "ALPURA" },
];

export const cuentaEspecialGSPOpciones = [
  { texto: "EDO VERACRUZ", valor: "EDO VERACRUZ" },
  { texto: "PE CAMPECHE", valor: "PE CAMPECHE" },
  { texto: "MAYOREO CERAMICO", valor: "MAYOREO CERAMICO" },
  { texto: "CAPDAM", valor: "CAPDAM" },
  { texto: "VIP", valor: "VIP" },
];

export const motivosNoProcedente = [
  { texto: "DE DEPENDENCIA A DEPENDENCIA", valor: "DE DEPENDENCIA A DEPENDENCIA" },
  { texto: "VEHÍCULO ESTACIONAMIENTO", valor: "VEHÍCULO ESTACIONAMIENTO" },
  { texto: "VEHÍCULO CON CARGA", valor: "VEHÍCULO CON CARGA" },
  { texto: "DE TALLER A TALLER", valor: "DE TALLER A TALLER" },
  { texto: "VEHÍCULO DESARMADO", valor: "VEHÍCULO DESARMADO" },
  { texto: "VEHÍCULO EN CORRALÓN", valor: "VEHÍCULO EN CORRALÓN" },
  { texto: "VEHÍCULO ATASCADO", valor: "VEHÍCULO ATASCADO" },
  { texto: "SIN FALLA MECÁNICA", valor: "SIN FALLA MECÁNICA" },
];

export const tipoCampo = [
  { texto: "texto", valor: "texto" },
  { texto: "lista", valor: "lista" },
];

export const siNo = [
  { texto: "Si", valor: true },
  { texto: "No", valor: false },
];

export const plOptions = [
  { label: "PL 1", value: "geo1" },
  { label: "PL 2", value: "geo2" },
];

//export const MAPBOX_TOKEN =
 // "pk.eyJ1IjoicGF0OTAwMCIsImEiOiJjbDI1ajk2cDkwMmNqM2tsZTE2ZWEyZTVrIn0.456pSXyxhu6zvPolqHsdtQ";

 export const MAPBOX_TOKEN =
  "pk.eyJ1IjoicGF0OTAwMCIsImEiOiJjbWlkdnlpaGEwMnUxMmtxOW83bml6OHQzIn0.FGrSzG2vdXMN1X6GXP42cQ";

export const mesesOptions = [
  { texto: "Ene", valor: 1 },
  { texto: "Feb", valor: 2 },
  { texto: "Mar", valor: 3 },
  { texto: "Abr", valor: 4 },
  { texto: "May", valor: 5 },
  { texto: "Jun", valor: 6 },
  { texto: "Jul", valor: 7 },
  { texto: "Ago", valor: 8 },
  { texto: "Sep", valor: 9 },
  { texto: "Oct", valor: 10 },
  { texto: "Nov", valor: 11 },
  { texto: "Dic", valor: 12 },
];

export const mesesOptions2 = [
  { label: "Todos", value: 0 },
  { label: "Ene", value: 1 },
  { label: "Feb", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Abr", value: 4 },
  { label: "May", value: 5 },
  { label: "Jun", value: 6 },
  { label: "Jul", value: 7 },
  { label: "Ago", value: 8 },
  { label: "Sep", value: 9 },
  { label: "Oct", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dic", value: 12 },
];

export const estatusOptions = [
  { texto: "Concluido", valor: 2 },
  { texto: "Otorgado", valor: 3 },
  { texto: "Cancelado con costo", valor: 4 },
  { texto: "Cancelado sin costo", valor: 5 },
];

export const estatusCanceladosOptions = [
  { texto: "Cancelado con costo", valor: 4 },
  { texto: "Cancelado sin costo", valor: 5 },
];

export const cambioConclusion = [
  "ricardo.perez@escotel.com.mx",
  "pat9000@hotmail.com",
  "sergio.bermeo@escotel.com.mx",
];

export const correosReporte = [
  "pat9000@hotmail.com",
  "angelica.herrera@escotel.com.mx",
  "fernando.aguirre@escotel.com.mx",
  "j.moragrega@escotel.com.mx",
  "wendolyn.briones@escotel.com.mx",
  "luisfernando@escotel.com.mx",
];

export const emailCambiarProveedor = [
  "ricardo.perez@escotel.com.mx",
  "pat9000@hotmail.com",
  "ivan.hidalgo@escotel.com.mx",
  "rafael.sosa@escotel.com.mx",
  "sergio.bermeo@escotel.com.mx",
];
export const correosCabiarCosto = [
  "pat9000@hotmail.com",
  "jose.almaguer@escotel.com.mx",
  "aline.reyes@escotel.com.mx",
];

export const correosConfirmaFactura = [
  "dante.delcastillo@escotel.com.mx",
  "elizabeth.cortes@escotel.com.mx",
  "andrea.jose@escotel.com.mx",
  "pat9000@hotmail.com",
  "monica.padilla@escotel.com.mx",
  "ricardo.perez@escotel.com.mx",
  "bruno.martinez@escotel.com.mx",
  "gustavo.dominguez@escotel.com.mx",
  "sergio.bermeo@escotel.com.mx",
];

export const puedeEstatusProveedor = [
  "pat9000@hotmail.com",
  "fernando.aguirre@escotel.com.mx",
  "ivan.hidalgo@escotel.com.mx",
];

export const correosAutorizaOPPrimerNivel = [
  "pat9000@hotmail.com",
  "angelica.herrera@escotel.com.mx",
  "j.moragrega@escotel.com.mx",
];

export const correosAutorizaOPSegundoNivel = [
  "pat9000@hotmail.com",
  "angelica.herrera@escotel.com.mx",
];

export const opcionesUsuriosUtorizarMasivo = [
  { texto: "Jose Moragrega", valor: "8de97c53-6ab1-4c30-8d0c-b1b657945cd9" },
  { texto: "Angelica Herrera", valor: "d8b506b7-873a-4a79-aa08-9245f773ffbc" },
];

export const correosPuedeAutorizarMasivo = [
  "pat9000@hotmail.com",
  "j.moragrega@escotel.com.mx",
  "daniel.lopez@escotel.com.mx",
  "luis.fernandez@escotel.com.mx",
];

export const correosReportes = [
  "pat9000@hotmail.com",
  "angelica.herrera@escotel.com.mx",
  "j.moragrega@escotel.com.mx",
  "fernando.aguirre@escotel.com.mx",
  "dante.delcastillo@escotel.com.mx",
  "wendolyn.briones@escotel.com.mx",
  "luisfernando@escotel.com.mx",
];

export const autorizacionesV2 = {
  contencion: [
    "jose.almaguer@escotel.com.mx",
    "aline.reyes@escotel.com.mx",
    "pat9000@hotmail.com",
    "axel.martinez@escotel.com.mx"
  ],
  validacion1: [
    "j.moragrega@escotel.com.mx",
    "angelica.herrera@escotel.com.mx",
    "pat9000@hotmail.com"
  ],
  validacion2: [
    "angelica.herrera@escotel.com.mx",
    "pat9000@hotmail.com"
  ],
  aplicarPagos: [
    "dante.delcastillo@escotel.com.mx",
    "monica.padilla@escotel.com.mx",
    "elizabeth.cortes@escotel.com.mx",
    "andrea.jose@escotel.com.mx",
    "pat9000@hotmail.com"
  ],
  validarFactura: [
    "pat9000@hotmail.com",
    "dante.delcastillo@escotel.com.mx",
    "elizabeth.cortes@escotel.com.mx",
    "monica.padilla@escotel.com.mx",
    "andrea.jose@escotel.com.mx"
  ],
  autorizarMasivo: [
    "j.moragrega@escotel.com.mx",
    "pat9000@hotmail.com"
  ]
};

export const emailsConAccesoDocumentos = [
  "pat9000@hotmail.com",
  "ivan.hidalgo@escotel.com.mx",
  "rafael.sosa@escotel.com.mx"
];

export const emailsEditarInfoPago = [
  "pat9000@hotmail.com",
  "ivan.hidalgo@escotel.com.mx",
];
